import React, { Component } from 'react';
import { EventEmitter } from 'fbemitter';
import { GeckoLoadingService } from '../../';
import './loading.scss';
import loader from 'assets/loader.svg';

class GeckoLoading extends Component {
  constructor(props) {
    super(props);

    if (!GeckoLoadingService.emitter)
      GeckoLoadingService.emitter = new EventEmitter();

    GeckoLoadingService.emitter.addListener('update', () => {
      const active = GeckoLoadingService.active;
      this.setState({ active });
    });
  }

  state = {
    active: false,
  };

  render() {
    if (this.state.active) {
      return (
        <div className="loader-bg">
          <div className="loader loading-indicator spinner-page-center">
            <img className="gecko-spinner" src={loader} alt="Loading Spinner" />
            <p>Loading...</p>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default GeckoLoading;
